import script from './option.vue_vue_type_script_lang.mjs';
export { default } from './option.vue_vue_type_script_lang.mjs';
import { render } from './option.vue_vue_type_template_id_2feb8304_lang.mjs';

script.render = render;
script.__file = "packages/components/select/src/option.vue";
//# sourceMappingURL=option.mjs.map
